import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddMemory = createAsyncThunk(
  "other/AddMemory",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/memory-create/`, data)
    return response.data
  }
); 

export const UpdateMemory = createAsyncThunk(
  "other/UpdateMemory",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/memory-update/${data.id}/`, data)
    return response.data
  }
);

export const GetMemoryList = createAsyncThunk(
  "user/GetMemoryList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/memory-list/`)
    return data
  }
);

export const DeleteMemory = createAsyncThunk(
  "other/DeleteMemory",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/memory-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

